import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import AuthCallback from "@/pages/AuthCallback";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Companies from "@/pages/Companies";
import CompanyDetail from "@/pages/CompanyDetail";
import WorkersList from "@/pages/WorkersList";
import WorkerDetail from "@/pages/WorkerDetail";
import SitesList from "@/pages/SitesList";
import SiteDetail from "@/pages/SiteDetail";
import EquipmentList from "@/pages/EquipmentList";
import EquipmentDetail from "@/pages/EquipmentDetail";
import Scadenzario from "@/pages/Scadenzario";
import Shares from "@/pages/Shares";
import PublicShare from "@/pages/PublicShare";
import Audit from "@/pages/Audit";
import UsersPage from "@/pages/Users";
import SearchPage from "@/pages/Search";
import StudiosPage from "@/pages/Studios";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/s/:token" element={<PublicShare />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/aziende" element={<Companies />} />
        <Route path="/aziende/:id" element={<CompanyDetail />} />
        <Route path="/lavoratori" element={<WorkersList />} />
        <Route path="/lavoratori/:id" element={<WorkerDetail />} />
        <Route path="/cantieri" element={<SitesList />} />
        <Route path="/cantieri/:id" element={<SiteDetail />} />
        <Route path="/attrezzature" element={<EquipmentList />} />
        <Route path="/attrezzature/:id" element={<EquipmentDetail />} />
        <Route path="/scadenzario" element={<Scadenzario />} />
        <Route path="/condivisioni" element={<Shares />} />
        <Route path="/audit" element={<Audit />} />
        <Route path="/utenti" element={<UsersPage />} />
        <Route path="/ricerca" element={<SearchPage />} />
        <Route path="/studi" element={<StudiosPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </AuthProvider>
  );
}
